export default __webpack_public_path__ + "static/media/doctor-telex.49e79e57.png";